import React from "react";

import { useTranslate } from "react-polyglot";
import styles from './Footer.module.scss';

function Footer() {
    const t = useTranslate();
    
    return (
        <div className={styles.footer}>
            <div className={styles.column + " " + styles.col1}>
                <h3>{t("fileupload.footer.title")}</h3>
                <p>{t("fileupload.footer.private.title")}</p>
                <p><a href={"tel:" + t("fileupload.footer.private.phone").replaceAll(" ", "")}>{t("fileupload.footer.private.phone")}</a></p>
                <p><a href={"mailto:" + t("fileupload.footer.private.email")}>{t("fileupload.footer.private.email")}</a></p>
                <p>&nbsp;</p>
            </div>
            <div className={styles.column + " " + styles.col2}>
                <h3>&nbsp;</h3>
                <p>{t("fileupload.footer.corporate.title")}</p>
                <p><a href={"tel:" + t("fileupload.footer.corporate.phone").replaceAll(" ", "")}>{t("fileupload.footer.corporate.phone")}</a></p>
                <p><a href={"mailto:" + t("fileupload.footer.corporate.email")}>{t("fileupload.footer.corporate.email")}</a></p>
                <p><a href={"mailto:" + t("fileupload.footer.corporate.email2")}>{t("fileupload.footer.corporate.email2")}</a></p>
            </div>
            <div className={styles.column + " " + styles.col3}>
                <p></p>
            </div>
        </div>
    );
};

export default Footer;